import OrgScopedPage from "./OrgScopedPage";
import KnowledgeBaseManager from "../KnowledgeBaseManager/KnowledgeBaseManager";

/**
 * PlatformKnowledgeBase — super-admin Knowledge Base page. Reuses the exact
 * tenant Knowledge Base Manager scoped to the selected organization.
 */
export default function PlatformKnowledgeBase() {
    return (
        <OrgScopedPage title="Knowledge Base" subtitle="Manage an organization's knowledge base articles and categories.">
            <KnowledgeBaseManager />
        </OrgScopedPage>
    );
}
